import React                      from 'react';
import SwivlChatProps             from './interface/SwivlChatProps'
import SwivlChatState             from './interface/SwivlChatState'
import SwivlChatInterface         from './interface/SwivlChatInterface'
import { SocketHandler }          from './sockets/SocketHandler'
import { MessageHandler }         from './messages/MessageHandler'
import { CommandHandler }         from './command/CommandHandler'
import { List }    from './List/List'
import { Form }    from './Form/Form'



// import { EmbedConfig } from '@swivl/swivl-lib'
import { Auth,  EmbedConfig,  EmbedCSS, SenderOrRecipientType } from '@swivl/swivl-lib'
import "./SwivlChat.scss";
import ListWrapper from './List/ListWrapper/ListWrapper';
import { Modal } from './Modals/Modal';
import { Config } from './Config/Config';



export default class SwivlChat extends React.Component<SwivlChatProps, SwivlChatState> implements SwivlChatInterface{

  // Socket Properties
  ref = React.createRef<HTMLDivElement>();

  // config:EmbedConfig;
  socketHandler:SocketHandler;
  messageHandler:MessageHandler;
  commandHandler:CommandHandler;
  hasStarted:boolean = false;

  list?:List;
  css?:any;
  isNewUser:boolean;
  // shouldStartOnConnect:boolean;
  constructor(props:SwivlChatProps) {
    super(props);
    
    let auth;

    Config.isReadOnly = props.isReadOnly || props.transcriptOnly
    Config.canPressButtons = !props.canTakeOver && !Config.isReadOnly
    Config.hideForm = props.hideForm || Config.isReadOnly
    Config.hidePastMessages = props.hidePastMessages 
    if (Config) {
      for (const key in props.config) {
        if (Object.prototype.hasOwnProperty.call(props.config, key)) {
          Config[key] = props.config[key];
        }
      }
    }    
    


    if (props.auth) {
      auth = this.props.auth;
      this.isNewUser = false;
      if (localStorage && !props.canTakeOver && !this.props.transcriptOnly) { localStorage.setItem("swivl_auth_" + Config.botId, JSON.stringify(auth)); }
    } else if (!this.props.transcriptOnly) {
      this.isNewUser = true;
      if (localStorage && localStorage.getItem("swivl_auth_" + Config.botId )) {
        var ls_auth = JSON.parse(localStorage.getItem("swivl_auth_" + Config.botId ))
        if (ls_auth) {
          this.isNewUser = false;
          if (ls_auth.userId && !ls_auth.botUserId && !props.canTakeOver) { 
            
            ls_auth.type = SenderOrRecipientType.BotUser;
            ls_auth.botUserId = ls_auth.userId; 
            localStorage.setItem("swivl_auth_" + Config.botId, JSON.stringify(ls_auth)); 

          }

          auth = ls_auth; // JSON.parse(localStorage.getItem("swivl_auth_" + Config.botId ));
        }
      }
    }

    

    this.state = {
      auth:auth, 
      hasStarted:false,
      isShowingModal:false, 
      modalContent:undefined
    }


    
    // Config = Config;

    
    if (this.props.generateCSS && Config && Config.botId ) {
      const css = EmbedCSS(Config, "#swivl_" + Config.botId);
      this.css =  (css) ? <style id="swivlCSS" dangerouslySetInnerHTML={{__html: css }} /> : null;
    }
    // this.shouldStartOnConnect = (Config.startConversationClosed || !props.parentControlsStart || (props.parentControlsStart  &&  props.isOpen)) ? true : false;

    this.startConversation = this.startConversation.bind(this)
    this.onConnect         = this.onConnect.bind(this);
    this.resetConversation = this.resetConversation.bind(this)

    this.socketHandler = new SocketHandler(this);
    this.messageHandler = new MessageHandler(this);
    this.commandHandler = new CommandHandler(this);

    this.triggerGoToQuest = this.triggerGoToQuest.bind(this);


    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  componentDidMount() {
    if (this.props.preloadedMessages) { this.list.addMessagesToList(this.props.preloadedMessages)}
    if (this.props.isOpen || Config.startConversationClosed) {
      if (this.props.transcriptOnly) {
        this.list.loadTranscript(this.props.transcriptDate)  
        return;
      }
      if (this.props.loadPastMessagesBeforeConnect) {
        this.list.loadPastMessages()
      }
      this.socketHandler.connect();
    }
  }
  onConnect() {

    
    // if (this.shouldStartOnConnect) {

    
      this.startConversation()
    // }
    /** if the sender is an agent and we are not doing a start conversation, we still need to register them with their token */
    if (this.state.auth && (this.state.auth.type === SenderOrRecipientType.Bot || this.state.auth.type === SenderOrRecipientType.Agent)) {
      this.messageHandler.sendAuthMessage();
    }
    if (this.props.onConnectionOpened) {
      this.props.onConnectionOpened();
    }
 }

/** Check to see if we the open state changed in this method.*/
 getSnapshotBeforeUpdate(prevProps, prevState) {  if ((!prevProps.isOpen && this.props.isOpen) || (prevProps.isOpen && !this.props.isOpen)) { return {openPropChanged : true}; }; return null;}
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot && snapshot.openPropChanged && !this.state.hasStarted && !snapshot.isTriggeringGoto) {

      if (!Config.startConversationClosed) {
        this.socketHandler.connect();
      }

      // this.startConversation();
    }
  }


  startConversation() {
    if (this.props.transcriptOnly) { 
      return; 
    }

    if (this.state.auth && this.props.canTakeOver) { // If it is a possibile takeover, load messages
      this.list.loadPastMessages();
    } else {
      if (this.state.auth) {
        if (Config.loadPastMessages) {
          this.list.loadPastMessages();
        }

        this.messageHandler.sendStartConversation();
      } else {

        this.messageHandler.sendCreateUserAndStartConversation();
      }
    }
    this.setState({hasStarted:true});
  }
  updateAuth(auth:Auth) {


    this.setState({auth:auth});
    if (localStorage && !this.props.canTakeOver) { localStorage.setItem("swivl_auth_" + Config.botId, JSON.stringify(auth)); }

  }
  resetConversation() {
    this.list?.resetList();
    if (localStorage && !this.props.canTakeOver) {
      localStorage.removeItem("swivl_auth_" + Config.botId);
    }
    this.setState({auth:null,hasStarted:false});
    setTimeout(()=>{    this.startConversation();     }, 200);
  }

  triggerGoToQuest(questId) {
    if (!this.state.hasStarted) {
      Config.startOnQuest = questId;
      if (Config.startConversationClosed) {
        this.startConversation();
      } else {
        this.socketHandler.connect()
      }
      return; 
    }
      if (!this.state.auth) { console.warn("missing auth"); return; }
      var xhr = new XMLHttpRequest();
      const url = "https://" + this.props.server + "/node_router/goto"
      xhr.open("POST", url, true); xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({questId:questId, auth:this.state.auth}));    
  }

  showModal(modalContent:React.ReactNode) {
    this.setState({isShowingModal:true, modalContent:modalContent})
  }
  hideModal() {
    if (this.state.isShowingModal || this.state.modalContent) {
      this.setState({isShowingModal:false, modalContent:undefined})
    }
  }

  componentWillUnmount(): void {
    console.warn("unmounting");
    this.socketHandler.disconnect();

  }

  render() {

    const form = (Config.hideForm || this.props.transcriptOnly) ? null : 
      <Form 
        delegate={this} 
        isConversationTakenOver={this.props.isConversationTakenOver} 
        canTakeoverViaSMS={this.props.canTakeoverViaSMS}
        />;

        const width = (this.ref && this.ref.current && this.ref.current.clientWidth) ? this.ref.current.clientWidth : 300; 
        const height = (this.ref && this.ref.current && this.ref.current.clientHeight) ? this.ref.current.clientHeight : 300; 

    return <div className={Config.hideForm ? "scc-noForm SwivlChat" : "SwivlChat"}
                id={"swivl_" + Config.botId}
                ref={this.ref}
                >
                  <Modal 
                    isShowing={this.state.isShowingModal} 
                    content={this.state.modalContent} 
                    hideModal={this.hideModal} 
                    />
      {this.css}
      <ListWrapper >
      <List 
        delegate={this} 
        auth={this.state.auth} 
        isNewUser={this.isNewUser} 
        hasStarted={this.state.hasStarted}
        isMobile={this.props.isMobile}
        isOpen={this.props.isOpen}
        isConversationTakenOver={this.props.isConversationTakenOver}
        width={width}
        height={height}
        />
        </ListWrapper>
      {form}
    </div>;
  }
}
